module.exports = __webpack_public_path__ + "static/media/copyDay.f65b50dc.svg";